import * as Yup from 'yup';

const propertyCategorySchema = Yup.object().shape({
  labelEn: Yup.string().required('Label En is required.'),
  labelAr: Yup.string().required('Label Ar is required.'),
  position: Yup.number()
    .min(0, "Please enter more than 0")
    .typeError("Must be Number"),
});

export default propertyCategorySchema;